import { useSupplierNotifications } from '@/context/SupplierNotificationsContext';
import { NotificationsPage } from '@/pages/rh/NotificationsPage';

const SupplierNotificationsPage = () => {
    const { notifications, loading, markAsRead, deleteNotifications } = useSupplierNotifications();
    return (
        <NotificationsPage ctx={{ notifications, loading, markAsRead, deleteNotifications }} />
    );
};

export default SupplierNotificationsPage;
